import { render, staticRenderFns } from "./table-football.vue?vue&type=template&id=5535d33c&scoped=true"
import script from "./table-football.vue?vue&type=script&lang=js"
export * from "./table-football.vue?vue&type=script&lang=js"
import style0 from "./table-football.vue?vue&type=style&index=0&id=5535d33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535d33c",
  null
  
)

export default component.exports